import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { initializeFilterData } from "../../EnvConfig/env_config";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, FindTranslatedKey, deleteData } from "../CommonComponents/CustomHooks";
import { handleDownloadExcel } from "../CommonComponents/ExportData";
import { FormButton, InputBox, SelectInputBox, Switch } from "../CommonComponents/InputBox";
import { Table } from "../CommonComponents/Table";

const GroupMasterForm = ({ menuText }) => {
    //--Inital State--//
    const dispatch = useDispatch();
    const inputrefs = useRef([]);
    const [loading, setLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [currentPageNo, setCurrentPageNo] = useState(1);
    let [result, setResult] = useState([]);
    const [filterData, setFilterData] = useState(initializeFilterData)

    const [formData, setFormData] = useState({
        userGroupID: '',
        groupName: '',
        active: true
    })

    //--Handle Clear Function--//
    const handleClear = () => {
        setFormData({
            userGroupID: '',
            groupName: '',
            active: true
        });
        filterData.SearchText = ''
        getGroupMasterData()
        inputrefs.current['txtGroupName'].focus();
    };

    //--handle Submit Function--//
    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall('/api/User/InsertUpdateUserGroupMaster', formData)
        await dispatch(setSubLoading(false))
        if (data.status === 'ERROR' || data.status === 'EXPIRED' || data.status === 'UNAUTHORIZED' || data.status === 'SUCCESS') {
            await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
        }
    }

    //--handle Delete Function--//
    const handleDelete = async (ID) => {
        await dispatch(setSubLoading(true))
        await deleteData('/api/User/DeleteUserGroupMaster', { userGroupID: ID }, getGroupMasterData, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    }

    //--handle Sorting Function--//
    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    //--handle Edit Function--//
    const handleEdit = async (id) => {
        await dispatch(setSubLoading(true))
        let editData = await ApiCall('/api/User/EditUserGroupMaster', { userGroupID: id })
        await dispatch(setSubLoading(false))
        if (editData.status === 'UNAUTHORIZED' || editData.status === 'ERROR' || editData.status === 'EXPIRED') {
            await NotificationSound(editData.status, editData.message, editData.focus, inputrefs);
        }
        else {
            let record = editData.data
            setFormData((pre) => ({
                ...pre, ...record
            }))
        }

    }

    //--Grid Data Fetch Function--//
    const getGroupMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            ...filterData,
            ...sortConfig,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        setLoading(true)
        let data = await ApiCall('/api/User/ShowUserGroupMaster', GetData)
        setResult(data)
        setLoading(false)
        if (data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message, data.focus, inputrefs);
        }
    }

    const handleChange1 = (event, value) => {
        getGroupMasterData(value);
    };



    useEffect(() => {
        getGroupMasterData();
    }, [sortConfig])

    useEffect(() => {
        inputrefs.current['txtGroupName'].focus();
        document.title = 'Group Master'
    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0"> {menuText ? menuText : FindTranslatedKey('Group Master')}</h6>
                </div>

                <div className='card-body row'>

                    <div className='row'>

                        <InputBox
                            label='Group Name'
                            required={true}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtActive'].focus()
                                }
                            }}
                            inputrefs={inputrefs}
                            id="txtGroupName"
                            PlaceHolderText='Group Name'
                            type="text"
                            maxLength='30'
                            value={formData.groupName}
                            onChange={(e) => setFormData({ ...formData, groupName: e.target.value })}
                        />
                        <Switch
                            label='Active'
                            checked={formData.active}
                            id='txtActive'
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['btnSub'].focus()
                                };
                            }}
                            onChange={(e) => setFormData({ ...formData, active: e.target.checked })}
                        />
                    </div>

                    <div className='row pb-1 mt-2'>
                        <FormButton
                            id='btnSave'
                            inputrefs={inputrefs}
                            handleSubmit={handleSubmit}
                            handleExport={async () => {
                                await dispatch(setSubLoading(true))
                                await handleDownloadExcel('/api/User/ShowUserGroupMaster', filterData, 'Group Master')
                                await dispatch(setSubLoading(false))
                            }}
                            handleClear={handleClear} />
                    </div>

                </div>

            </div>
            <Table handleEdit={handleEdit}
                handleDelete={handleDelete}
                PageName={'GroupMaster'}
                loading={loading}
                handleFilter={() => {
                    getGroupMasterData()
                    setFilterData({
                        ...filterData,
                    })
                }}
                filterData={filterData}
                tableData={result}
                setFilterData={setFilterData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
            />

        </>
    )
}

export default GroupMasterForm;